import {
  PostList as PostListComponent,
  PostListProps,
} from '@tribeplatform/react-components/PostList'

import { BC } from '../../types/index.js'

export const PostListBlock: BC<PostListProps> = PostListComponent
